<span class="text-wrap text-break" *ngIf="propertyLine">
  <ng-container [ngSwitch]="(propertyService.getAll$ | async | find: 'Id': propertyLine.PropertyId)?.TypeClv">
    <ng-container *ngSwitchCase="propertyTypes.Numeric">{{propertyLine.NumericValue}}</ng-container>
    <ng-container *ngSwitchCase="propertyTypes.Choice">{{(classificatorValueService.getAll$ | async | find: 'Id': propertyLine.ValueClv)?.Value}}</ng-container>
    <ng-container *ngSwitchCase="propertyTypes.Text">{{propertyLine.Value}}</ng-container>
    <ng-container *ngSwitchDefault></ng-container>
  </ng-container>

</span>
